/** @jsx jsx */
import { jsx, ThemeUIStyleObject, Image as ThemeUIImage } from "theme-ui"
import React from "react"
import { PrimitiveProps } from "@styles/types"

export interface ImageProps
  extends PrimitiveProps,
    React.ComponentPropsWithRef<"img"> {
  src?: string
  alt?: string
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void
}

export const imageStyles: ThemeUIStyleObject = {}

const Image: React.FC<ImageProps> = React.forwardRef(
  ({ sx, src, alt, onLoad, ...props }, ref) => {
    if (!src) return null

    return (
      <ThemeUIImage
        ref={ref}
        sx={{ ...imageStyles, ...sx }}
        {...props}
        src={src}
        alt={alt}
        {...(onLoad && { onLoad: onLoad })}
      />
    )
  }
)

Image.defaultProps = {}

export { Image }
